import {useEffect, useState} from 'react';

/**
 * 检测是否为移动端的自定义Hook
 * @param breakpoint 断点宽度，默认为1960px
 * @returns 是否为移动端
 */
export const useIsMobile = (breakpoint: number = 1960): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    // 初始检测
    checkScreenSize();

    // 监听窗口大小变化
    window.addEventListener('resize', checkScreenSize);

    // 清理事件监听器
    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, [breakpoint]);

  return isMobile;
};